import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  stadiuemLabel: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 16,
  },
  stadiumLabelComplete: {
    border: '1px solid #2E7D3280',
  },
  stadiumLabelInProgress: {
    border: '1px solid #ED6C0280',
  },
  stadiumLabelArchived: {
    border: '1px solid #00000042',
  },
  stadiumLabelText: {
    fontSize: 13,
    padding: '3px 6px',
  },
  stadiumLabelTextComplete: {
    color: '#2E7D32',
  },
  stadiumLabelTextInProgress: {
    color: '#ED6C02',
    padding: '3px 6px',
  },
  stadiumLabelTextArchived: {
    color: '#000000',
  },
}));
